export default __webpack_public_path__ + "static/icono_usuaria-0edd5cb8666475f0b0ae319689982084.png";